import {ClientEvent, Tracker} from '@udemy/event-tracking';
import {ExperimentImpressionEvent} from '@udemy/react-experimentation-provider';

const UI_REGION = 'at_risk_help_modal';
const DEFAULT_SOURCE = 'jbi';

/** @options in schema-store for the AtRiskHelpCTASelected event. */
export const AT_RISK_HELP_CTA = {
    RESUME_COURSE: 'resume_course',
    EXPLORE_COURSES: 'explore_courses',
    TRY_SKILL_ASSESSMENTS: 'try_skill_assessments',
    CONFIRM_REMINDER: 'confirm_reminder',
    SUBMIT_FEEDBACK: 'submit_feedback',
    DONE: 'done',
} as const;

export type AtRiskHelpCtaType = (typeof AT_RISK_HELP_CTA)[keyof typeof AT_RISK_HELP_CTA];

export class AtRiskHelpModalPresented extends ClientEvent {
    source: string;
    uiRegion = UI_REGION;

    constructor({source = DEFAULT_SOURCE}: {source?: string} = {}) {
        super('AtRiskHelpModalPresented');
        this.source = source;
    }
}

export class AtRiskHelpOptionSelected extends ClientEvent {
    optionValue: string;
    source: string;
    uiRegion = UI_REGION;

    constructor({optionValue, source = DEFAULT_SOURCE}: {optionValue: string; source?: string}) {
        super('AtRiskHelpOptionSelected');
        this.optionValue = optionValue;
        this.source = source;
    }
}

export class AtRiskHelpCTASelected extends ClientEvent {
    ctaType: AtRiskHelpCtaType;
    stepId: string;
    source: string;
    uiRegion = UI_REGION;

    constructor({
        ctaType,
        stepId,
        source = DEFAULT_SOURCE,
    }: {
        ctaType: AtRiskHelpCtaType;
        stepId: string;
        source?: string;
    }) {
        super('AtRiskHelpCTASelected');
        this.ctaType = ctaType;
        this.stepId = stepId;
        this.source = source;
    }
}

export const trackAtRiskHelpModalPresented = (source?: string) => {
    Tracker.publishEvent(new AtRiskHelpModalPresented({source}));
};

export const trackAtRiskHelpOptionSelected = (optionValue: string, source?: string) => {
    Tracker.publishEvent(new AtRiskHelpOptionSelected({optionValue, source}));
};

export const trackAtRiskHelpCtaSelected = (
    ctaType: AtRiskHelpCtaType,
    stepId: string,
    source?: string,
) => {
    Tracker.publishEvent(new AtRiskHelpCTASelected({ctaType, stepId, source}));
};

export const trackAtRiskHelpExperimentImpression = (assignment?: {
    experimentIds: number[];
    isLocalDefault: boolean;
}) => {
    if (!assignment) return;
    Tracker.publishEvent(
        new ExperimentImpressionEvent(assignment.experimentIds, assignment.isLocalDefault),
    );
};
